import ky from 'ky';
class HTTPError extends Error {}
const client = ky.extend({
  prefixUrl: `${process.env.REACT_APP_IMAGE_URL}api/`,
  hooks: {
    beforeRequest: [
      (request) => {
        // Do something before every request
        // This is a good place to authorize request if needed
      }
    ],
    afterResponse: [
			// Or retry with a fresh token on a 403 error
			async (request, options, response) => {
				if (response.status === 401) {
          const body = await response.json()
          throw new HTTPError(body.message);
				}
			}
    ]
  }
});

export default client;